module.exports = __webpack_public_path__ + "img/icon-right.12497cf5.svg";